import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import InvoiceBatchItem from '../../entities/invoiceBatchItem';
import InvoiceBatch from '../../entities/invoiceBatch';
export function deleteInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoiceBatchItem.id;}
const _work = workingSet();
store.getState().invoiceBatches.getMappingFor('invoiceBatchItemId', invoiceBatchItem.id).filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D').forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.filter(id => id !== invoiceBatchItem.id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
});



invoiceBatchItem.status = 'D';
invoiceBatchItem.addedOn = newHRTimestamp();
invoiceBatchItem.addedBy = getCurrentUserId();
invoiceBatchItem.importSource = targetImportSource;
invoiceBatchItem.importId = mergeId;
store.dispatch(Actions.InvoiceBatchItemActions.removeInvoiceBatchItemQueue(invoiceBatchItem));
}
export function replaceInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, replaceWith: InvoiceBatchItem, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoiceBatchItem.id;}
const _work = workingSet();
store.getState().invoiceBatches.getMappingFor('invoiceBatchItemId', invoiceBatchItem.id).filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D').forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.map(id => (id === invoiceBatchItem.id) ? replaceWith.id : id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
});



return invoiceBatchItem;
}
export function deleteImpactInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem) {
const impacts: string[] = [];
const state = store.getState();
const invoiceBatchInvoiceBatchItemIdsImpact = state.invoiceBatches.getMappingFor('invoiceBatchItemId', invoiceBatchItem.id).filter(invoiceBatch => invoiceBatch.status !== 'D');
invoiceBatchInvoiceBatchItemIdsImpact.forEach(() => impacts.push('invoiceBatches'));



return util.countDistinct(impacts);
}
